enum AudienceTemplateModalType {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
}

export default AudienceTemplateModalType;
